document.addEventListener("DOMContentLoaded", function () {
    function updateCartCount() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(data => {
                const itemCount = data.item_count;
                document.getElementById('cart-count').textContent = itemCount; // Using the correct ID
            })
            .catch(error => console.error('Error fetching cart data:', error));
    }

    // Update cart count when the page is loaded
    updateCartCount();

    // Listen for AJAX events related to cart functionality
    document.addEventListener('ajaxify.cart.updated', function () {
        updateCartCount(); // Update count when the cart is updated
    });

    // Handle add-to-cart actions for forms
    document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
        form.addEventListener('submit', function(event) {
            event.preventDefault();
            const formData = new FormData(form);

            fetch(form.action, {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
            .then(response => response.json())
            .then(data => {
                // Dispatch an event to notify the cart has been updated
                document.dispatchEvent(new Event('ajaxify.cart.updated'));
            })
            .catch(error => console.error('Error adding to cart:', error));
        });
    });
});

document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', function(event) {
        event.preventDefault(); // Prevent default form submission
        const formData = new FormData(form); // Collect form data

        // AJAX request to add an item to the cart
        fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json(); // Parse JSON response
        })
        .then(data => {
            // Dispatch an event to notify the cart has been updated
            document.dispatchEvent(new Event('ajaxify.cart.updated'));
        })
        .catch(error => console.error('Error adding to cart:', error));
    });
});

function updateCartCount() {
    fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
            const itemCount = data.item_count;
            document.getElementById('cart-count').textContent = itemCount; // Update the cart count
        })
        .catch(error => console.error('Error fetching cart data:', error));
}

// Invoke this function when the page loads
document.addEventListener("DOMContentLoaded", updateCartCount);

// Listen for your custom event to update the cart count
document.addEventListener('ajaxify.cart.updated', updateCartCount);

document.addEventListener("DOMContentLoaded", function () {
    
    // Function to update item quantity
    function updateCartQuantity(lineItemId, quantity) {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ line: lineItemId, quantity: quantity }) // Update quantity
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
            document.dispatchEvent(new Event('ajaxify.cart.updated')); // Notify cart has been updated
            // Optionally update cart price displays, item totals, etc. here
        })
        .catch(error => console.error('Error updating cart:', error));
    }

    // Event listeners for quantity buttons
    document.querySelectorAll('.js-qty__adjust js-qty__adjust--plus').forEach(button => {
        button.addEventListener('click', function(event) {
            const cartItem = event.target.closest('.cart-item');
            const quantityInput = cartItem.querySelector('.js-qty');
            const lineItemId = quantityInput.dataset.line; // Assuming line item id is stored here
            let newQuantity = Math.max(1, parseInt(quantityInput.value) + 1); // Prevents negative
            quantityInput.value = newQuantity; // Update the display
            updateCartQuantity(lineItemId, newQuantity); // Call function to update cart
        });
    });

    document.querySelectorAll('.js-qty__adjust js-qty__adjust--minus').forEach(button => {
        button.addEventListener('click', function(event) {
            const cartItem = event.target.closest('.cart-item');
            const quantityInput = cartItem.querySelector('.js-qty');
            const lineItemId = quantityInput.dataset.line; // Assuming line item id is stored here
            let newQuantity = Math.max(1, parseInt(quantityInput.value) - 1); // Prevents negative
            quantityInput.value = newQuantity; // Update the display
            updateCartQuantity(lineItemId, newQuantity); // Call function to update cart
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
    
    // Function to update item quantity
    function updateCartQuantity(lineItemId, quantity) {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ line: lineItemId, quantity: quantity }) // Update quantity
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
            document.dispatchEvent(new Event('ajaxify.cart.updated')); // Notify cart has been updated
            // Optionally update cart price displays, item totals, etc. here
        })
        .catch(error => console.error('Error updating cart:', error));
    }

    // Event listeners for quantity buttons
    document.querySelectorAll('.js-qty__adjust js-qty__adjust--plus').forEach(button => {
        button.addEventListener('click', function(event) {
            const cartItem = event.target.closest('.cart-item');
            const quantityInput = cartItem.querySelector('.js-qty');
            const lineItemId = quantityInput.dataset.line; // Assuming line item id is stored here
            let newQuantity = Math.max(1, parseInt(quantityInput.value) + 1); // Prevents negative
            quantityInput.value = newQuantity; // Update the display
            updateCartQuantity(lineItemId, newQuantity); // Call function to update cart
        });
    });

    document.querySelectorAll('.js-qty__adjust js-qty__adjust--minus').forEach(button => {
        button.addEventListener('click', function(event) {
            const cartItem = event.target.closest('.cart-item');
            const quantityInput = cartItem.querySelector('.js-qty');
            const lineItemId = quantityInput.dataset.line; // Assuming line item id is stored here
            let newQuantity = Math.max(1, parseInt(quantityInput.value) - 1); // Prevents negative
            quantityInput.value = newQuantity; // Update the display
            updateCartQuantity(lineItemId, newQuantity); // Call function to update cart
        });
    });
});